<template>
  <div class="bar" :class="classes">
    <div class="meter" :style="style"></div>
  </div>
</template>

<script>
export default {
  name: 'Bar',
  props: {
    size: Number,
    scala: {
      type: Number,
      default: 5
    },
    faded: Boolean
  },
  computed: {
    style () {
      return {
        width: `${this.size / this.scala * 100}%`
      }
    },
    classes () {
      return {
        'color-tint': !this.faded,
        'faded': this.faded
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bar {
  width: 100%;
  height: 0.5rem;
  background: #eee;
  
  &.faded {
    color: #999;
  }

  .meter {
    height: inherit;
    background-color: currentcolor;
  }
}
</style>


// WEBPACK FOOTER //
// Bar.vue?4e7c3554